import { useGetCustomerQuery } from "../../utils/customer.utils";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import { useParams } from "react-router-dom";
import CustomerProfileContainer from "./CustomerProfileContainer";

export default function CustomerProfilePage() {
  const { customer_id } = useParams();
  const { loading, data } = useGetCustomerQuery({
    query: `?cid=${customer_id ?? ""}`
  });

  const breadCrumbs = [
    {
      name: "Pages",
      link: "/pages"
    },
    {
      name: "Customer",
      link: "/customer"
    },
    {
      name: "Profile"
    }
  ];

  const isLoading = loading;

  return (
    <PageLayout
      title="Profile"
      subTitle={data?.name ?? ""}
      breadCrumbs={breadCrumbs}
      style={{ hasCardBg: false, className: "pt-4", cardBodyClass: "p-0" }}>
      {loading ? "Loading..." : ""}
      <CustomerProfileContainer data={data ?? {}} />
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
